import { ApiService } from "./api.service";
import { PrimeIcons } from "@primevue/core/api";
export default class InventoryReceivingService extends ApiService {
  namespace = "receiving";
  icon = "PalletizedBoxes";
  name = "Type";
  favicon = "CubeBlue";

  Width = 1400;
  DOMAIN = -48;
  action = "action";
  singular = this.terminology.type.singular;
  plural = this.terminology.type.plural;
  vowel = this.terminology.type.vowel;

  gemMenuItems = [
    {
      key: "create",
      label: "Adding an Inventory Receiving",
      icon: PrimeIcons.LIST,
    },
  ];
  columns = [
    {
      header: this.t("Number"),
      icon: "Shred",
      field: "number",
    },
    {
      header: "Item",
      icon: "Tag",
      field: "number",
    },
    {
      header: "Created BY",
      icon: "UserSilhouette",
      field: "created_by",
    },
    {
      header: "Created",
      icon: "Calendar",
      field: "created",
    },
  ];
  navItems = [
    {
      key: "listing",
      label: this.t("allEntity", { entity: this.plural }),
      icon: "Bullets",
    },
    {
      key: "bookmark",
      label: this.t("viewMyBookmarks", { entity: this.singular }),
      icon: "Bookmark",
    },
    {
      key: "inactive",
      label: this.t("viewInactiveEntity", { entity: this.plural }),
      services: 18,
      icon: "Disable",
    },
  ];
  constructor() {
    super("receiving");
  }
}
